import { UnfoldMoreVerticalIcon } from './UnfoldMoreVerticalIcon';

/**
 * author: Austin Andrews
 * id AE8D43D2-00EC-46D9-A21C-4D0024A539D7
 * name unfold-more-vertical
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/unfold-more-vertical.svg
 * tags
 */
export const ExpandVerticalIcon = UnfoldMoreVerticalIcon;
export default ExpandVerticalIcon